'use client';
type SignupItem = {
  signupText: string;
};
export default function CarouselBullets({
  signupItems,
  activeIndex,
  onBulletClick,
}: {
  signupItems: SignupItem[];
  activeIndex: number;
  onBulletClick: (index: number) => void;
}) {
  return (
    <ul className="slider-bullets">
      {signupItems?.map((signup, index) => (
        <li
          key={index}
          onClick={() => onBulletClick(index)}
          className={activeIndex === index ? 'active' : ''}
        >
          {signup?.signupText}
        </li>
      ))}
    </ul>
  );
}
